export class InputGoNext {
    constructor(optionalOptions = {}) {
        this._inputs = document.querySelectorAll('.input-go-next');

        if (!this._inputs) {
            this.destructor();
            return true;
        }

        this._inputs.forEach((input) => {
            input.addEventListener("keyup", (event) => {
                let key = event.keyCode || event.charCode;

                if (key === 8 || key === 46 ) {
                    let prevEl = input.previousElementSibling;
                    if (prevEl && prevEl.nodeName === 'INPUT') {
                        prevEl.focus();
                    }

                    return false;
                }

                let isNumber = input.value.replace(/[^0-9]/g,'')

                if (!isNumber || isNumber === '' || isNumber === ' ')
                    return false

                if (isNumber > 9) input.value = input.value.substring(input.value.length - 1, input.value.length)

                //if (key === 8 && input.value === '') {
                //    let prevEl = input.previousElementSibling;
                //    if(prevEl.nodeName === 'INPUT') {
                //        prevEl.focus();
                //    }
                //}

                if (!input.classList.contains('input-go-last')) {
                    let nextEl = input.nextElementSibling;
                    if (nextEl.nodeName === 'INPUT') {
                        nextEl.focus();
                    }
                }
            })
        })
    }

    destructor() {
        this._inputs = null;
    }
}

export default new InputGoNext();